module.exports = __webpack_public_path__ + "static/the-book-of-why-c983ae2a330212cdd3ec04694d1b02f7.jpg";